export default __webpack_public_path__ + "static/media/283.3cf8bda0.jpg";